// Cloud urls
const LOC_CLOUD_URL         = "http://localhost:8090/";
const PROD_CLOUD_URL        = "https://fast-brook-7822.herokuapp.com/";
const PROD2_CLOUD_URL       = "https://wlcloud.herokuapp.com/";
const DEV_CLOUD_URL         = "https://wlcloud-dev.herokuapp.com/";
const DEV2_CLOUD_URL        = "https://wlcloud-dev2.herokuapp.com/";

// Parse Server urls
const LOC_PARSE_SERVER_URL  = "https://wlparse-test.herokuapp.com/parse";
const PROD_PARSE_SERVER_URL = "https://wlparse-server.herokuapp.com/parse";
const DEV_PARSE_SERVER_URL  = "https://wlparse-test.herokuapp.com/parse";

// Parse Api Keys
const PARSE_PROD_APP_ID      = "ONChr2vcewJxAhcy2Lr9mBfxLuaupfApRj9UUDdg";
const PARSE_DEV_APP_ID       = "wlparse-test-app-id";

const PARSE_CLIENT_ID       = "U8mWfxsColFYOSmN1mvPfmkLQGUsafwpq8g9AMkD";
const PARSE_REST_KEY        = "B77W5iK6lsci1nz9VNSkg8dqzdaY21X76dd6ASdt";

// Hardcoded Publishable Key
const PARSE_PROD_SP_KEY = "pk_live_3TZ00AdEFYtHxBWPM5atRbDX";
const PARSE_DEV_SP_KEY = "pk_test_9rebpjLpnprSUiMkJluSG7pb";

// Hardcoded spClientId Key
const PARSE_PROD_SP_CLIENT_ID = "ca_7nxIszcq04fDyCxR2F34qOmqWVUdEYg0";
const PARSE_DEV_SP_CLIENT_ID = "ca_7nxIXI9iBpjsKuEZeEVTAXSihqhqnw6G";

// defined the global variable
const STRIPE_PERCENTAGE        = 2.9;
const STRIPE_CENTS             = 0.30;
const DEFAULT_EXPORT_ORDER_LIMIT = 200;
const DEFAULT_ORDER_LIMIT        = 50;
const DEFAULT_CUSTOMER_LIMIT     = 100;
const DEFAULT_EXPORT_CUSTOMER_LIMIT  = 200;



const configHelper = {
    CLOUD_URLS : {
        prod  : JSON.stringify(PROD_CLOUD_URL),
        prod2 : JSON.stringify(PROD2_CLOUD_URL),
        dev   : JSON.stringify(DEV_CLOUD_URL),
        dev2  : JSON.stringify(DEV2_CLOUD_URL),
        loc   : JSON.stringify(LOC_CLOUD_URL)
    },

    PARSE_SERVER_URLS : {
        prod  : JSON.stringify(PROD_PARSE_SERVER_URL),
        prod2 : JSON.stringify(PROD_PARSE_SERVER_URL),
        dev   : JSON.stringify(DEV_PARSE_SERVER_URL),
        dev2  : JSON.stringify(DEV_PARSE_SERVER_URL),
        loc   : JSON.stringify(LOC_PARSE_SERVER_URL)
    },

    PARSE_APP_IDS : {
        prod  : JSON.stringify(PARSE_PROD_APP_ID),
        prod2 : JSON.stringify(PARSE_PROD_APP_ID),
        dev   : JSON.stringify(PARSE_DEV_APP_ID),
        dev2  : JSON.stringify(PARSE_DEV_APP_ID),
        loc   : JSON.stringify(PARSE_DEV_APP_ID)
    },

    PARSE_SP_KEYS : {
        prod  : JSON.stringify(PARSE_PROD_SP_KEY),
        prod2 : JSON.stringify(PARSE_PROD_SP_KEY),
        dev   : JSON.stringify(PARSE_DEV_SP_KEY),
        dev2  : JSON.stringify(PARSE_DEV_SP_KEY),
        loc   : JSON.stringify(PARSE_DEV_SP_KEY)
    },

    PARSE_SP_CLIENT_IDS : {
        prod  : JSON.stringify(PARSE_PROD_SP_CLIENT_ID),
        prod2 : JSON.stringify(PARSE_PROD_SP_CLIENT_ID),
        dev   : JSON.stringify(PARSE_DEV_SP_CLIENT_ID),
        dev2  : JSON.stringify(PARSE_DEV_SP_CLIENT_ID),
        loc   : JSON.stringify(PARSE_DEV_SP_CLIENT_ID)
    },

    // Test Modes indicates that business and user created should be in test or live mode
    // Stripe test or live keys will be used accordingly
    TEST_MODES : {
        prod  : JSON.stringify(false),
        prod2 : JSON.stringify(false),
        dev   : JSON.stringify(true),
        dev2  : JSON.stringify(true),
        loc   : JSON.stringify(true)
    },

    PARSE_CLIENT_ID  : JSON.stringify(PARSE_CLIENT_ID),
    PARSE_REST_KEY   : JSON.stringify(PARSE_REST_KEY),
    STRIPE_PERCENTAGE   : STRIPE_PERCENTAGE,
    STRIPE_CENTS   : STRIPE_CENTS,
    DEFAULT_EXPORT_ORDER_LIMIT   : DEFAULT_EXPORT_ORDER_LIMIT,
    DEFAULT_ORDER_LIMIT   : DEFAULT_ORDER_LIMIT,
    DEFAULT_CUSTOMER_LIMIT   : DEFAULT_CUSTOMER_LIMIT,
    DEFAULT_EXPORT_CUSTOMER_LIMIT   : DEFAULT_EXPORT_CUSTOMER_LIMIT,

    // get available environment setting
    getEnvironment : function(CLOUD_ENV) {
        switch(CLOUD_ENV) {
            case 'prod':
                return 'prod';
            case 'prod2':
                return 'prod2';
            case 'dev':
                return 'dev';
            case 'dev2':
                return 'dev2';
            case 'loc':
                return 'loc';
            default:                // in case ...
                return 'dev';
        };
    }
};

module.exports = configHelper;



// WEBPACK FOOTER //
// ConfigHelper.js